module.exports = __webpack_public_path__ + "static/img/new-logo.a13f972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-logo.png
// module id = 936
// module chunks = 173